<div class="page-header">
  <h2>Switch 51 – Port Security</h2>
  <button class="btn-refresh" (click)="loadPorts()" [disabled]="loading || !isConfigured">
    {{ loading ? 'Loading…' : 'Refresh' }}
  </button>
</div>

<!-- Password setup — shown when EncryptedPassword is missing from appsettings -->
@if (!isConfigured) {
  <div class="setup-box">
    <p class="setup-title">Switch password is not configured.</p>
    <p class="setup-hint">Enter the switch password below. It will be encrypted and saved to appsettings automatically.</p>
    <div class="setup-row">
      <input type="password"
             [(ngModel)]="passwordInput"
             placeholder="Switch password"
             class="password-input"
             (keyup.enter)="savePassword()"
             [disabled]="savingPassword" />
      <button class="btn-save-pw"
              (click)="savePassword()"
              [disabled]="savingPassword || !passwordInput.trim()">
        {{ savingPassword ? 'Saving…' : 'Encrypt & Save' }}
      </button>
    </div>
    @if (passwordError) {
      <div class="error-bar">{{ passwordError }}</div>
    }
  </div>
}

@if (error) {
  <div class="error-bar">{{ error }}</div>
}

@if (loading && ports.length === 0) {
  <div class="loading-state">Connecting to switch…</div>
}

@if (ports.length > 0) {
  <table class="ports-table">
    <thead>
      <tr>
        <th>Port</th>
        <th>Description</th>
        <th>Status</th>
        <th>MAC Address</th>
        <th>Host</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (p of ports; track p.port) {
        <tr>
          <td class="port-num">{{ p.port }}</td>
          <td>{{ p.description || '—' }}</td>
          <td>
            <span class="status-badge" [ngClass]="statusClass(p.status)">{{ p.status }}</span>
          </td>
          <td class="mac">{{ p.macAddress || '—' }}</td>
          <td>{{ p.hostName || '—' }}</td>
          <td class="actions-cell">
            <div class="action-row">
              <button class="btn-learn"
                      [disabled]="actionState[p.port] != null"
                      (click)="learn(p.port)">
                {{ actionState[p.port] === 'learn' ? 'Working…' : 'Learn Current' }}
              </button>

              @if (isDisabled(p.status)) {
                <button class="btn-enable"
                        [disabled]="actionState[p.port] != null"
                        (click)="enable(p.port)">
                  {{ actionState[p.port] === 'enable' ? 'Working…' : 'Enable' }}
                </button>
              } @else {
                <button class="btn-block"
                        [disabled]="actionState[p.port] != null"
                        (click)="block(p.port)">
                  {{ actionState[p.port] === 'block' ? 'Working…' : 'Block' }}
                </button>
              }
            </div>

            @if (actionResult[p.port]) {
              <div class="action-feedback"
                   [ngClass]="actionResult[p.port]!.ok ? 'feedback-ok' : 'feedback-err'">
                {{ actionResult[p.port]!.msg }}
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
}
